const DATE_FORMAT = "Y-MM-DD";
const DATETIME_FORMAT = "Y-MM-DD H:mm:ss";
const DATETIME_FORMAT_FILE_NAME = "Y-MM-DD_Hmmss";
const DATE_PICKER_FORMAT = "Y-m-d";
const DATE_FORMAT_JA = "Y年MM月DD日";
const DATETIME_NOT_SECONDS_FORMAT = "Y-MM-DD H:mm";
const DATETIME_NOT_SECONDS_FORMAT_JA = "Y年MM月DD日 H:mm";
const PHONE_FORMAT = /^[\d-]*$/;
const LICENSES = [1,3,5,10,20,30,40,50,60,70,80,90,100];

export {
  DATE_FORMAT,
  DATE_PICKER_FORMAT,
  DATETIME_FORMAT,
  DATE_FORMAT_JA,
  DATETIME_NOT_SECONDS_FORMAT,
  DATETIME_NOT_SECONDS_FORMAT_JA,
  PHONE_FORMAT,
  DATETIME_FORMAT_FILE_NAME,
  LICENSES,
};
